module.exports = __webpack_public_path__ + "img/nobu_logo-black.439f9689.svg";